import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	CircularProgress,
	IconButton,
	ListItem,
	Paper
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import EmojiObjectsIcon from "@material-ui/icons/EmojiObjects";
import NoteAddOutlinedIcon from "@material-ui/icons/NoteAddOutlined";
import MenuText from "components/Typography/MenuText";
import React, { useEffect, useState } from "react";
import { Anchorme } from "react-anchorme";
import { getACleanURI, getLabelOf } from "../../../helpers/utilities";
import useStyles from "../CockpitStyleJs/styleTabInfo.js";
import lod_ from "lodash";
import AttachmentsList from "helpers/AttachmentsList";
import { sanitize } from "dompurify";
import { useSelector } from "react-redux";
import Subject from "../Message/components/Subject";
import GenerateAnswerReply from "../ConvActions/GenerateAnswerReply";

/**
 *
 * @param {object} ans The answer item (1 object = 1 alternative)
 * @param {number} indexaccordion The index of the accordion
 * @param {function} handleReplaceReview The function to replace the review
 * @param {function} handleReplaceAnswer The function to replace the answer
 * @param {string} loadingBuiltin The loading builtin
 * @returns
 */
export default function BuiltInAnswer({
	ans,
	indexaccordion,
	handleReplaceReview,
	handleReplaceAnswer,
	loadingBuiltin,
	useAction = true
}) {
	const user = useSelector(state => state.userStatus?.auth?.user);
	const { language } = useSelector(state => state.answers);
	const { selectedConversation } = useSelector(state => state.cockpit);
	const { assistantconfig } = useSelector(state => state);

	const [expandedAcordion, setExpandedAccordion] = useState(false);
	const [replyGenerate, setReplyGenerate] = useState({
		open: false
	});

	const ongoingConv = selectedConversation?.header.state === "ongoing";
	const resolvedConv = selectedConversation?.header.state === "resolved";
	const assignedConv = selectedConversation?.agent?.uid === user.email;
	const displayActions = (ongoingConv || resolvedConv) && assignedConv && useAction;
	const classes = useStyles();

	const [content, setContent] = useState({});

	const checkActionReply = actions => {
		if (lod_.isNil(actions) || lod_.isEmpty(actions)) {
			return [];
		}

		const filteredActions = actions.filter(action => {
			let conditions = action?.conditions ?? {};
			if (lod_.isEmpty(conditions) || lod_.isNil(conditions)) {
				return true;
			}

			for (let key of Object.keys(conditions)) {
				let value = conditions[key];
				if (lod_.get(selectedConversation, key) === value) {
					return true;
				}
			}

			return false;
		});

		return filteredActions ?? [];
	};

	const editorActions = checkActionReply(
		assistantconfig?.actions
			?.filter(action => action.scope === "editor" && action.active === true)
			.sort((a, b) => {
				const rankA = a.rank ?? Infinity;
				const rankB = b.rank ?? Infinity;
				return rankA - rankB;
			})
	);

	let loadingElement;
	if (`panel_${indexaccordion}` === loadingBuiltin) {
		loadingElement = (
			<div className="builtin-answer-load-ressource">
				<CircularProgress></CircularProgress>
			</div>
		);
	}

	const getAnswerType = () => {
		switch (ans.version) {
			case "2.0":
				return ans.format;
			case "1.0":
			default:
				return ans.type;
		}
	};

	const canGenerateAnswerReply = !lod_.isEmpty(editorActions) && !lod_.isEmpty(ans.code ?? ans.uid);

	const handleOpenGenerateAnswerReply = event => {
		event.stopPropagation();
		setReplyGenerate({
			open: true
		});
	};

	useEffect(() => {
		// Open accordion
		setExpandedAccordion(ans.open || false);

		// Set content of the answer
		switch (ans.version) {
			case "2.0": {
				let ansContent = lod_.get(ans.content, language);
				// Check if the content not exist for the language selected, try to get the first language available
				if (!ansContent && ans.content && ans.content.length > 0) {
					const firstLanguageKey = Object.keys(ans.content[0])[0];
					if (firstLanguageKey) {
						ansContent = ans.content[0][firstLanguageKey];
					}
				}
				setContent(ansContent || {});
				break;
			}
			case "1.0":
			default: {
				let ansContent = lod_.find(ans.content, { language })?.content;
				setContent(ansContent || {});
				break;
			}
		}
	}, [ans, language]);

	return (
		<>
			<Accordion
				className={classes.root}
				onClick={() => {
					setExpandedAccordion(!expandedAcordion);
				}}
				key={indexaccordion}
				expanded={expandedAcordion}
			>
				<div className={classes.addAnswer}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls={`panel_${indexaccordion}bh-content`}
						id={`panel_${indexaccordion}d-header`}
						classes={{ root: classes.customAccordionSummary }}
						key={indexaccordion}
					>
						{
							<h5 style={{ fontSize: "16px", fontFamily: "Roboto", fontWeight: "normal" }}>
								{ans.description
									? SliceWord(getLabelOf(ans.description), 47)
									: SliceWord(getLabelOf(ans.name), 47)}
							</h5>
						}
					</AccordionSummary>
					{displayActions && (
						<Box display="flex" alignItems="center">
							<IconButton
								onClick={e => {
									let format = ans.type;

									switch (ans.version) {
										case "2.0":
											format = ans.format;
											break;
										case "1.0":
										default:
											break;
									}

									if (format === "review") {
										handleReplaceReview(content);
									} else {
										switch (ans.version) {
											case "2.0":
												handleReplaceAnswer(
													indexaccordion,
													ans.code,
													ans.name,
													user,
													lod_.cloneDeep(content),
													ans.alternativeIndex
												);
												break;
											case "1.0":
											default:
												handleReplaceAnswer(
													indexaccordion,
													ans.uid,
													ans.name,
													user,
													lod_.cloneDeep(content),
													null
												);
												break;
										}
									}
									e.stopPropagation();
								}}
								size="small"
							>
								<NoteAddOutlinedIcon />
							</IconButton>
							{canGenerateAnswerReply && (
								<IconButton
									onClick={handleOpenGenerateAnswerReply}
									disabled={Boolean(
										selectedConversation.actions?.some(
											a => a.code === "replyAssistant" && a.state === "processing"
										)
									)}
									size="small"
								>
									<EmojiObjectsIcon />
								</IconButton>
							)}
						</Box>
					)}
					{loadingElement}
				</div>
				<AccordionDetails className={classes.AccordionDetails}>
					<ListItem style={{ padding: "8px" }}>
						<Box width={1}>
							{!lod_.isNil(content?.attachments) && content.attachments.length > 0 && (
								<div
									style={{
										position: "absolute",
										top: 10,
										right: 10
									}}
								>
									<AttachmentsList attachments={content.attachments} />
								</div>
							)}
							<Paper
								elevation={3}
								onClick={e => {
									e.stopPropagation();
								}}
							>
								<Box display="flex" p={1} alignItems="center">
									<Box
										flexGrow={1}
										alignItems="right"
										// maxWidth="240px"
										style={{ overflow: "hidden" }}
									>
										{content && <RenderAnswerByType content={content} type={getAnswerType()} />}
									</Box>
								</Box>
							</Paper>
						</Box>
					</ListItem>
				</AccordionDetails>
			</Accordion>
			<GenerateAnswerReply
				open={replyGenerate.open}
				answerItemSelected={ans}
				actions={editorActions}
				onClose={() =>
					setReplyGenerate({
						open: false
					})
				}
			/>
		</>
	);
}

const RenderAnswerByType = ({ content, type }) => {
	switch (type) {
		case "review":
			return <div style={{ whiteSpace: "pre-line" }}>{content.text}</div>;
		case "menutext":
			return <MenuText menuTitle={content.title} menuText={content.choice} />;
		case "menu":
			if (content.menu?.choices) {
				const filteredChoices = content.menu.choices.filter(
					choice => choice.label && choice.label.trim() !== ""
				);
				const formattedChoices = filteredChoices.map(choice => ({
					value: choice.label,
					label: choice.label
				}));
				return <MenuText menuTitle={content.menu.subject} menuText={formattedChoices} />;
			}
			return null;
		case "menuyesno":
			return content.title;
		case "richtext":
			return (
				<Anchorme target="_blank" rel="noreferrer noopener">
					<div>{content.text}</div>
				</Anchorme>
			);
		case "askemail":
		case "htmltext":
			return (
				<Anchorme target="_blank" rel="noreferrer noopener">
					{content.subject?.length > 0 && <Subject urgent={false} topic={content.subject} />}
					<div
						dangerouslySetInnerHTML={{
							__html: sanitize(content.text)
						}}
					/>
				</Anchorme>
			);
		case "document":
			if (content.attachments) {
				return (
					<Box>
						{content.text && (
							<Anchorme target="_blank" rel="noreferrer noopener">
								<div>{content.text}</div>
							</Anchorme>
						)}
						{content.attachments &&
							content.attachments.map((attachment, index) => {
								if (attachment.mimeType?.startsWith("image/")) {
									return <img key={index} src={getACleanURI(attachment.url)} alt="Content" />;
								}
								return (
									<Box key={index} mt={1}>
										<Anchorme target="_blank" rel="noreferrer noopener" truncate={50}>
											{getACleanURI(attachment.url)}
										</Anchorme>
									</Box>
								);
							})}
					</Box>
				);
			}
			// Old format
			return (
				<Anchorme target="_blank" rel="noreferrer noopener" truncate={50}>
					{getACleanURI(content.url)}
				</Anchorme>
			);
		case "video":
			return (
				<Anchorme target="_blank" rel="noreferrer noopener" truncate={50}>
					{getACleanURI(content.url)}
				</Anchorme>
			);
		case "image":
			return <img src={getACleanURI(content.url)} alt="Content" />;
		case "location":
			if (content.location) {
				// New format
				return (
					<div>
						<div>{content.location.name}</div>
						<div>{content.location.address}</div>
					</div>
				);
			}
			// Old format
			return <div>{content.addressName}</div>;
		case "link":
			if (content.link) {
				return (
					<div>
						{content.link.title && <div style={{ fontWeight: "bold" }}>{content.link.title}</div>}
						{content.link.description && <div>{content.link.description}</div>}
						<Anchorme target="_blank" rel="noreferrer noopener">
							<div style={{ marginTop: "5px" }}>{content.link.link}</div>
						</Anchorme>
						{content.link.footer && (
							<div style={{ fontStyle: "italic", marginTop: "5px" }}>{content.link.footer}</div>
						)}
					</div>
				);
			}
			return null;
		case "contact":
			if (content.contact) {
				return (
					<div>
						<div style={{ fontWeight: "bold" }}>
							{content.contact.firstName} {content.contact.lastName}
						</div>
						{content.contact.company && <div>{content.contact.company}</div>}
						{content.contact.email && (
							<Anchorme target="_blank" rel="noreferrer noopener">
								<div>{content.contact.email}</div>
							</Anchorme>
						)}
						{content.contact.phone && <div>{content.contact.phone}</div>}
						{content.contact.street && (
							<div>
								{content.contact.street}, {content.contact.zip} {content.contact.city},{" "}
								{content.contact.country}
							</div>
						)}
					</div>
				);
			}
			return null;
		case "locationRequest":
			if (content.locationRequest?.text) {
				return <div>{content.locationRequest.text}</div>;
			}
			return null;
		default:
			return "";
	}
};
/**
 *
 * @param {function} String Cut the word if it is too long and cannot be displayed
 */

function SliceWord(str, length) {
	if (str.length > length) {
		return str.slice(0, length);
	} else {
		return str;
	}
}
